import React from 'react';
import { Button } from '@/components/button';
import { createStyles } from '@/contexts/theme-context';
import { FilterPills } from '@/components/filter-pills';
import { FONTS, TYPOGRAPHY } from '@/styles';
import { PillButtonType } from '@/components/pill-button';
import { Text } from 'react-native';

interface Props {
  filterPills: PillButtonType[];
}

export const OrderCheckInFilter: React.FC<Props> = ({ filterPills }) => {
  const [styles, theme] = useStyles();
  return (
    <FilterPills
      buttons={filterPills}
      containerStyle={styles.pillContainer}
      disableClear
      renderPillButton={(pill) => (
        <Button
          key={pill.label}
          leftElement={<Text style={styles.countText}>{pill.count}</Text>}
          leftElementStyle={styles.countWrapper}
          onPress={pill.onPress}
          size="xsmall"
          style={[
            styles.pillButton,
            {
              backgroundColor: pill.active
                ? theme.colors.primary
                : theme.sk.color.bg.secondary.default,
            },
          ]}
          testID={`${pill.label}: ${pill.count}`}
          textStyle={[
            TYPOGRAPHY.pSemiBold,
            styles.pillText,
            {
              color: pill.active ? theme.sk.color.text.ondark : undefined,
            },
          ]}
          trackingData={{
            name: `check_in_filter_pills.${pill.label}`,
          }}
        >
          {pill.label}
        </Button>
      )}
    />
  );
};

const useStyles = createStyles((theme) => ({
  countText: {
    ...FONTS.primarySemiBold,
    color: theme.sk.color.text.secondary,
    fontSize: 12,
    textAlign: 'center',
  },
  countWrapper: {
    backgroundColor: theme.sk.color.bg.primary.default,
    borderRadius: 20,
    height: 20,
    justifyContent: 'center',
    marginRight: 8,
    minWidth: 20,
    paddingHorizontal: 4,
  },
  pillButton: {
    backgroundColor: theme.colors.primary,
    borderRadius: 36,
    borderWidth: 0,
    height: 32,
    marginRight: 8,
    paddingLeft: 6,
    paddingRight: 16,
  },
  pillContainer: {
    marginHorizontal: 0,
    paddingVertical: 0,
  },
  pillText: {
    fontSize: 14,
  },
}));
